
<template>
  <div>Settings Management</div>
</template>

<script>
export default {
  name: "ManagementSettings",
  data() {
    return {

    };
  },
  computed: {
    // Get the top 5 ranked options
    topRankedOptions() {
      return this.dataset.sort((a, b) => b.rank - a.rank).slice(0, 5);
    },
  },
  methods: {
    clearOptions(){
      this.selectedItems = [];
    },
    updateAutocomplete() {
      if (this.searchQuery.length > 0) {
        this.autocompleteSuggestions = this.dataset
          .filter((item) =>
            item.title.toLowerCase().includes(this.searchQuery.toLowerCase())
          )
          .slice(0, 5); // Limit to 5 suggestions
      } else {
        this.autocompleteSuggestions = [];
      }
    },
    selectSuggestion(suggestion) {
      if (!this.selectedItems.some((item) => item.id === suggestion.id)) {
        this.selectedItems.push(suggestion);
      }
      this.searchQuery = "";
      this.autocompleteSuggestions = [];
    },
    removeItem(item) {
      const index = this.selectedItems.findIndex((i) => i.id === item.id);
      if (index !== -1) {
        this.selectedItems.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
